import './AppGroupSelect.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { getDirectParent } from '@lib/popups';
import { Select } from 'antd';
import sortBy from 'lodash/sortBy';
import { StakeholderType } from '@sonar-software/sonar-core';
import { useStakeholders } from '@hooks';
import React, { useMemo } from 'react';
export const AppGroupSelect = ({ getPopupContainer, onChange, placeholder, value }) => {
    const stakeholders = useStakeholders(false);
    const options = useMemo(() => sortBy(stakeholders
        .filter((stakeholder) => stakeholder.stakeholderType === StakeholderType.Team)
        .map((group) => ({
        label: group.name,
        value: group.stakeholderId
    })), (group) => group.label), [stakeholders]);
    return (React.createElement(Select, { allowClear: true, className: 'app-group-select', getPopupContainer: getPopupContainer !== null && getPopupContainer !== void 0 ? getPopupContainer : getDirectParent, onChange: onChange, optionFilterProp: 'label', options: options !== null && options !== void 0 ? options : [], placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : COPY_SPECIFIC.GROUP, popupClassName: 'app-group-select-dropdown', showSearch: true, value: value }));
};
